import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CheckRequestTypeEnum } from '@qaroni-app/check/types/check-request-type.enum';

@Component({
  selector: 'qaroni-check-requests-type-preview',
  templateUrl: './check-requests-type-preview.component.html',
  styleUrl: './check-requests-type-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckRequestsTypePreviewComponent {
  readonly requestType = input<CheckRequestTypeEnum>(
    CheckRequestTypeEnum.STORE
  );

  get ngClassTextColor(): string {
    switch (this.requestType()) {
      case CheckRequestTypeEnum.STORE:
        return 'text-success font-bold';
      case CheckRequestTypeEnum.UPDATE:
        return 'text-primary-40 font-bold';
      default:
        return 'text-neutral-40 font-bold';
    }
  }
}
